<script lang="ts">
  import { Col, Row } from "sveltestrap";
  import Card from "../../Core/Card.svelte";
  import data from "../../../Data/SocialApp/SocialApp.json"
  import NewUsersSocial from "./NewUsersSocial.svelte";
  import LikeContent from "./LikeContent.svelte";

</script>
<Col xl="6" lg="12" md="7" class="xl-60 box-col-8">
    <Row>
        {#each data.usercontentdata as socialItem}
            <Col sm="12">
                <Card>
                    <div slot="contentbody">
                        <NewUsersSocial socialItem={socialItem}/>
                        <LikeContent socialItem={socialItem} />
                    </div>
                </Card>
            </Col>
        {/each}
    </Row>
</Col>